import { Injectable, Injector } from '@angular/core';
import {
  AbstractControl,
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { Income } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .authOnce$()
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: Income) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity?.ownerId],
        incomeValue: [entity?.incomeValue || null, Validators.required],
      },
      options,
    );
  }

  generate(entity: Income[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      ownerId: this.userId,
    });
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
